// extracted by mini-css-extract-plugin
export var acitonButtons = "_gn-0";
export var additionalIcon = "_gn-f";
export var block = "_gn-1";
export var blockContent = "_gn-7";
export var blockDescription = "_gn-8";
export var blockIcon = "_gn-9";
export var blockTitle = "_gn-6";
export var border = "_gn-a";
export var center = "_gn-l";
export var edge = "_gn-b";
export var edgeLabel = "_gn-c";
export var edgePath = "_gn-d";
export var error = "_gn-e";
export var flowchart = "_gn-g";
export var flowchartContent = "_gn-h";
export var highlighted = "_gn-3";
export var hover = "_gn-4";
export var icon = "_gn-i";
export var left = "_gn-m";
export var navButton = "_gn-j";
export var navButtons = "_gn-k";
export var right = "_gn-n";
export var selected = "_gn-2";
export var small = "_gn-5";